import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { Button } from "@mui/material";

export const WhiteStyledButton = styled(Button)`
    && {
        color: ${UIStyleConstants.WHITE_COLOR};
        padding-left: 14px;
        padding-right: 14px;

        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0px;
        text-align: left;

        &:hover {
            border-bottom: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
            border-radius: 0;
        }
    }
`;
